import { useEffect, useRef, useCallback } from "react";
// Controls
import { TaskAttachmentRow } from "./TaskAttachmentRow";
// Styles
import { getClassNames, getStyles } from "./TaskAttachmentList.styles";
// Utilities
import map from "lodash/map";
import * as React from "react";
import { ChangeFocusBeforeRemovalIFocusable } from "@ms/uno-utilities/lib/local/FocusUtilities";
export function TaskAttachmentList(props) {
    const { taskAttachmentRowItems, taskAttachmentRowStrings, taskAttachmentRowIcons, documentPreviewIcons } = props;
    const { onEditTaskAttachment, onSelectDeselectShowOnCard, onOpenLink, onCopyLink } = props.callbacks;
    const { hideShowOnCardButton, hideOpenInNewWindow, disableEdit, disableRemove, disableCopyLink, disableActionButton, hideMoreButton } = props.rowConfig;
    const styles = getStyles(props.styles);
    const classNames = getClassNames(styles);
    const attachmentElements = useRef({});
    const attachmentMenuElements = useRef({});
    // always reset attachmentElements and attachmentMenuElements on re-render
    attachmentElements.current = {};
    attachmentMenuElements.current = {};
    const prevPropsRef = useRef(props);
    React.useEffect(()=>{
        if (prevPropsRef.current.taskAttachmentToEditIndex != null) {
            if (prevPropsRef.current.isTaskAttachmentBeingEdited && prevPropsRef.current.taskAttachmentToEditIndex >= 0) {
                // Reset focus on element that was edited.
                // Note: this is referenced by index since the element url can also be modified and a new url attachment will be replaced and a new AttachmentRow component will be mounted.
                // If the name is edited and the attachment order changes, the focus will be set where the edited attachment used to be.
                if (attachmentMenuElements[prevPropsRef.current.taskAttachmentToEditIndex]) {
                    attachmentMenuElements[prevPropsRef.current.taskAttachmentToEditIndex].element.focus();
                }
            }
        }
    });
    useEffect(()=>{
        prevPropsRef.current = props;
    });
    /**
     * Helper to call the right functions when a task attachment is deleted
     * @param taskAttachmentRowItem Task attachment being deleted
     */ const onDeleteAttachment = useCallback((taskAttachmentRowItem)=>{
        if (props.altFocusableElement != null) {
            ChangeFocusBeforeRemovalIFocusable(Object.values(attachmentElements.current), ()=>{
                props.altFocusableElement?.focus();
            }, taskAttachmentRowItem.url);
        }
        props.callbacks.onDeleteTaskAttachment(taskAttachmentRowItem);
    }, [
        attachmentElements,
        props.altFocusableElement,
        props.callbacks
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames.root
    }, /*#__PURE__*/ React.createElement("ul", null, map(taskAttachmentRowItems, (taskAttachmentRowItem)=>{
        const itemCallbacks = {
            onDelete: ()=>onDeleteAttachment(taskAttachmentRowItem),
            onEdit: ()=>onEditTaskAttachment(taskAttachmentRowItem),
            onSelectDeselectShowOnCard: (status)=>onSelectDeselectShowOnCard(taskAttachmentRowItem, status),
            onOpenLink,
            onCopyLink
        };
        const rowConfig = {
            hideShowOnCardButton,
            hideOpenInNewWindow,
            disableEdit,
            disableRemove,
            disableCopyLink,
            disableActionButton,
            hideMoreButton
        };
        return /*#__PURE__*/ React.createElement(TaskAttachmentRow, {
            key: taskAttachmentRowItem.url,
            taskAttachmentRowItem: taskAttachmentRowItem,
            callbacks: itemCallbacks,
            taskAttachmentIconRef: (element)=>{
                attachmentElements.current[taskAttachmentRowItem.url] = {
                    element: element,
                    id: taskAttachmentRowItem.url
                };
            },
            taskAttachmentMenuButtonRef: (element)=>{
                attachmentMenuElements.current[taskAttachmentRowItem.url] = {
                    element: element,
                    id: taskAttachmentRowItem.url
                };
            },
            config: rowConfig,
            taskAttachmentRowStrings: taskAttachmentRowStrings,
            styles: styles.subComponentStyles?.row,
            icons: taskAttachmentRowIcons,
            documentPreviewIcons: documentPreviewIcons,
            enableExternalUrlRegexCheck: props.enableExternalUrlRegexCheck
        });
    })));
}
